<script>
import Layout from '@layouts/main'
import LeftBar from '@components/left-bar-actions'

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { Layout, LeftBar },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <div
    :class="$style.title"
    style="height: calc(100vh - 195px); display: flex; justify-content:center;align-items:center; flex-direction: column;"
  >
    <LeftBar hidden />
    <h1 class="mb-10">
      Página não encontrada
    </h1>
    <h3 class="mt-10 mb-5">
      Não foi possível acessar o endereço, mas você pode:
    </h3>
    <br />
    <BaseLink
      name="home"
      class="text-primary"
      style="text-decoration: underline"
    >
      Voltar para a página inicial
    </BaseLink>
  </div>
</template>

<style lang="sass" module>
.title
  text-align: center
</style>
